import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { SmsVerificationStyled } from '../../asset/styled/SmsVerificationStyled';
import { getAlertMessageFunction } from '../../common/Util';
import { getSmsBirthLoginCheck } from '../login/loginSlice';
import Typography from '../../components/common/Typography';
import TextField from '../../components/common/TextField';
import Button from '../../components/common/Button';

import login_logo from '../../asset/img/login_logo_img.png';
import payday_logo from '../../asset/img/common/logo.svg';

const BirthVerification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation('smsVerification');
  const { isLogin } = useSelector(state => state.login);
  const searchParams = new URLSearchParams(location.search);
  const session = searchParams.get('key');
  const server = searchParams.get('server') || 'jan';
  const [form, setForm] = useState({
    birth: '',
  });
  useEffect(() => {
    if (isLogin) {
      navigate('/AuthComplete');
    }
  }, [isLogin]);

  const handleChange = e => {
    const { name, value } = e.target;
    let _value = value.replace(/[^0-9]/g, '');
    _value = _value.slice(0, 6);

    console.log('_value', _value);
    setForm({ ...form, [name]: _value });
  };

  const handleSubmit = () => {
    try {
      const alertMessage = getAlertMessageFunction();
      sStorage.setItem('sessionId', session);
      sStorage.setItem('htmAlias', server);

      //생년월일을 입력해주세요.
      if (form.birth.length !== 6) {
        alertMessage(t('alertMessage01'));
        return;
      }

      //잘못된 접근입니다.
      if (!session) {
        alertMessage(t('alertMessage02'));
        return;
      }
      // 모바일 여부 확인
      const isMobile = /Mobi|Android/i.test(navigator.userAgent);
      dispatch(
        getSmsBirthLoginCheck({
          htmCertKey: session,
          birth: form.birth,
          mFlag: isMobile ? "M" : "1", // 모바일이면 "m" 추가
          alias: server,
        }),
      );
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <SmsVerificationStyled>
      <div className="verification_container">
        <div className="displayFlex" style={{ justifyContent: 'space-between' }}>
          <div className="displayFlexColumn" style={{ gap: '8px' }}>
            <img src={payday_logo} alt="payday_logo" />
            <Typography className="logo_text">{t('header1')}</Typography>
          </div>
          <img src={login_logo} alt="login logo" width="145px" />
        </div>
        <div className="displayFlexColumn" style={{ gap: '10px' }}>
          <div className="displayFlexColumn" style={{ gap: '10px' }}>
            <TextField
              placeholder={t('birthVerification')}
              variant="login"
              size="large"
              type="password"
              name="birth"
              value={form.htmComPass}
              onChange={handleChange}
            />
            <Button size="large" value={t('birthVerificationButton')} onClick={handleSubmit} />
          </div>
          <div>
            <Typography className="desc_text">{t('verificationDescription')}</Typography>
          </div>
        </div>
      </div>
    </SmsVerificationStyled>
  );
};

export default BirthVerification;
